export const menuItems = [
    { label: 'О компании', link: '/about' },
    { label: 'Доставка и оплата', link: '/delivery' },
    { label: 'Возврат', link: '/return' },
    { label: 'Контакты', link: '/contacts' },
];

export const categoriesItems = [
    { label: 'Бытовая химия', link: '/household-chemicals' },
    { label: 'Косметика и гигиена', link: '/cosmetics' },
    { label: 'Товары для дома', link: '/home-products' },
    { label: 'Товары для детей и мам', link: '/children-mothers-products' },
    { label: 'Посуда', link: 'tableware' },
];
